import React, { useEffect, useState } from "react";
import { Row, Col, Form, Button, Image, InputGroup } from "react-bootstrap";
import "./index.css";
import "./userCompanyInfo.css";
import { useDialog } from "../../../../helpers/useDialog";
import { useDispatch, useSelector } from "react-redux";
import LogisticPartnerAuth from "../../../auth/LogisticPartnerAuth";
import PageSpinner from "../../../common/PageSpinner";
import axios from "axios";
import { BHAREE_BASE_URL_LOCAL } from "../../../../config/config.url";
import inputValidation from "../../../../utils/inputValidation";
import CustomDragDrop from "../../../common/CustomDragDrop";
import isEmpty from "../../../../utils/is-Empty";
import CustomButton from "../../../common/CustomButton";
import { toast } from "react-toastify";
import VehicleList from "./VehicleList";
import { normalizeImages } from "../../../../utils/normalizeImages";
import Select from "react-select";
import { getApi } from "../../../../actions/structure.action";

const VehicleInfo = ({ title = "Other Vehicles", userId }) => {
  const dispatch = useDispatch();
  const { alert, confirm, DialogModal } = useDialog();
  const [errorMsg, setErrorMsg] = useState("");
  const [loading, setLoading] = useState(false);
  const [otherVehicles, setOtherVehicles] = useState([]);
  const [isCreateMode, setIsCreateMode] = useState(false);
  const [isUpdateMode, setIsUpdateMode] = useState(false);
  const [uploadFormObj, setUploadFormObj] = useState({});
  const [vehicleTypesList, setVehicleTypesList] = useState([]);

  const { requestCall, auth, vehicleTypes } = useSelector((state) => state);

  useEffect(() => {
    getOtherVehicles();
    getApi("getVehicleTypes", dispatch);
  }, []);

  useEffect(() => {
    if (!isEmpty(vehicleTypes) && !isEmpty(vehicleTypes?.data) && vehicleTypes?.data.length > 0) {
      setVehicleTypesList(vehicleTypes?.data);
    } else {
      setVehicleTypesList([]);
    }
  }, [vehicleTypes]);

  const getOtherVehicles = async () => {
    setLoading(true);
    try {
      const response = await axios.get(
        BHAREE_BASE_URL_LOCAL + "/logistics/getOtherVehicles/" + userId,
        {
          headers: {
            Authorization: `Bearer ${localStorage.jwtToken}`,
          },
        },
      );
      console.log("getOtherVehicles: ", response);
      if (response && response?.data) {
        if (response?.data?.success) {
          setOtherVehicles(response?.data?.data?.otherVehicles);
        }
      }
      return response;
    } catch (error) {
      console.error("Upload error:", error.response || error.message);
      throw error;
    } finally {
      setLoading(false);
    }
  };

  const addVehicleInfo = (mode) => {
    setIsCreateMode(false);
    setIsUpdateMode(false);
    if (mode === "add") {
      setIsCreateMode(true);
    } else {
      setIsUpdateMode(true);
    }
  };

  const onSelectValue = (key, value) => {
    // console.log("*** change ", key, value)
    let updatedObj = {};
    updatedObj[key] = value;

    setUploadFormObj((previousValues) => ({
      ...previousValues,
      ...updatedObj,
    }));
  };

  const onSelectValueValidation = (key, value, maxLength = 1000, numericOnly = false) => {
    setErrorMsg({});
    let updatedObj = {};
    let validate = inputValidation(value, maxLength, numericOnly);
    if (validate.pass) {
      updatedObj[key] = validate.finalValue;
      setUploadFormObj((previousValues) => ({
        ...previousValues,
        ...updatedObj,
      }));
    } else {
      setErrorMsg({ [key]: validate.msg });
    }
  };

  const handleFileChange = (files, nameKey) => {
    const newImageData = [];
    for (let i = 0; i < files?.length; i++) {
      let imageKey = `image_${i + 1}`;
      newImageData.push({ key: imageKey, file: files[i] });
    }

    if (Object.prototype.hasOwnProperty.call(uploadFormObj, "imageData")) {
      setUploadFormObj((prevState) => {
        const newArray = [...prevState.imageData];
        newImageData.map((item) => {
          return newArray.push(item);
        });
        return { ...prevState, imageData: newArray };
      });
    } else {
      let updatedObj = {};
      !isEmpty(nameKey)
        ? (updatedObj[nameKey] = newImageData)
        : (updatedObj["imageData"] = newImageData);

      setUploadFormObj((previousValues) => ({
        ...previousValues,
        ...updatedObj,
      }));
    }
  };

  const createUpdateVehicle = async (e) => {
    e.preventDefault();
    console.log("Form Submitted: ", uploadFormObj);

    const formData = new FormData();

    // Loop through each key in uploadFormObj
    for (const key in uploadFormObj) {
      const value = uploadFormObj[key];

      if (Array.isArray(value)) {
        for (const item of value) {
          if (item.file instanceof File) {
            formData.append(key, item.file, item.file.name);
          } else if (item.file?.path) {
            // Fetch path as blob if using a URL
            const blob = await fetch(item.file.path).then((r) => r.blob());
            formData.append(key, blob, item.file.path);
          }
        }
      } else {
        // This is a simple field
        formData.append(key, value);
      }
    }

    let mErrors = [];
    if (isEmpty(uploadFormObj?.logistic_vehicle_type)) {
      mErrors.push("Please select vehicle make and type.");
    }
    if (mErrors.length > 0) {
      await alert(mErrors.join("<br/>"));
      return;
    }

    setLoading(true);
    try {
      let response = null;
      if (isCreateMode) {
        response = await axios.post(
          BHAREE_BASE_URL_LOCAL + "/logistics/addVehicle/" + userId,
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
              "Access-Control-Allow-Origin": "*",
              Authorization: `Bearer ${localStorage.jwtToken} `,
            },
          },
        );
      } else {
        response = await axios.patch(
          `${BHAREE_BASE_URL_LOCAL}/logistics/updateVehicle/${userId}/${uploadFormObj.id}`,
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
              "Access-Control-Allow-Origin": "*",
              Authorization: `Bearer ${localStorage.jwtToken} `,
            },
          },
        );
      }

      console.log("Success: ", response);

      if (response && response.data) {
        if (response.data.success) {
          toast.success(response.data.message);
        } else {
          toast.error(response.data.message);
        }

        // Close this page and move to the previous one
        setIsCreateMode(false);
        setIsUpdateMode(false);
        setUploadFormObj({});
        setErrorMsg({});
        getOtherVehicles();
      }
      return response;
    } catch (error) {
      console.error("Upload error:", error.response || error.message);
      throw error;
    } finally {
      setLoading(false);
    }
  };

  const vehicleInfoForm = () => {
    return (
      <>
        <Row className="m-0 form-row">
          <Row className="m-0 px-0 w-full px-0 title-button-row">
            <Col md={6}>
              <h2 className="m-0 p-0">{isCreateMode ? "Add Vehicle" : "Update Vehicle"}</h2>
            </Col>
            <Col md={6} className="text-end">
              <Button
                className="btn-theme"
                size="sm"
                onClick={() => {
                  setIsCreateMode(false);
                  setIsUpdateMode(false);
                  getOtherVehicles();
                }}
              >
                <i class="bi bi-chevron-left"></i> Go Back
              </Button>
            </Col>
          </Row>
          <Form className="modal-custom-class mt-3" onSubmit={createUpdateVehicle}>
            <Row className="m-0">
              <h4>{"Basic Info"}</h4>
              <Col xs={12} md={6}>
                <Form.Group className="mb-3">
                  <Form.Label>
                    {"Driver Contact Number"}
                    <span className="redStreSpan">*</span>
                  </Form.Label>
                  <InputGroup>
                    <Form.Control
                      type="text"
                      value={uploadFormObj?.driver_contact || ""}
                      required
                      onChange={(e) =>
                        onSelectValueValidation("driver_contact", e.target.value, 10, true)
                      }
                      maxLength={10}
                    />
                  </InputGroup>
                </Form.Group>
              </Col>
              <Col xs={12} md={6}>
                <Form.Group className="mb-3">
                  <Form.Label>
                    {"Driver Name"}
                    <span className="redStreSpan">{"*"}</span>
                  </Form.Label>
                  <Form.Control
                    type="text"
                    value={uploadFormObj?.driver_name || ""}
                    required
                    onChange={(e) => onSelectValueValidation("driver_name", e.target.value, 50)}
                  />
                </Form.Group>
              </Col>
              <Col xs={12} md={6}>
                <Form.Group className="mb-3">
                  <Form.Label>
                    {"Driver Email"}
                    <span className="redStreSpan">*</span>
                  </Form.Label>
                  <Form.Control
                    type="email"
                    value={uploadFormObj?.driver_email || ""}
                    required
                    onChange={(e) => onSelectValue("driver_email", e.target.value)}
                  />
                </Form.Group>
              </Col>
              <Col xs={12} md={6}>
                <Form.Group className="mb-3">
                  <Form.Label>
                    {"Driver License Number"}
                    <span className="redStreSpan">*</span>
                  </Form.Label>
                  <Form.Control
                    type="text"
                    required
                    value={uploadFormObj?.driver_license_no || ""}
                    onChange={(e) =>
                      onSelectValueValidation("driver_license_no", e.target.value, 20)
                    }
                  />
                </Form.Group>
              </Col>
              <Col xs={12}>
                <Form.Group className="mb-3">
                  <Form.Label>
                    {"Driver License Copy (PNG/JPG/PDF ≤ 2MB)"}
                    <span className="redStreSpan">*</span>
                  </Form.Label>
                  {isUpdateMode && (
                    <CustomDragDrop
                      onUplodfiles={handleFileChange}
                      nameKey={"driver_license_copy"}
                      allowMultiple={false}
                      existingFiles={
                        uploadFormObj?.driver_license_copy
                          ? [uploadFormObj?.driver_license_copy]
                          : []
                      }
                    />
                  )}
                  {isCreateMode && (
                    <CustomDragDrop
                      onUplodfiles={handleFileChange}
                      nameKey={"driver_license_copy"}
                      allowMultiple={false}
                    />
                  )}
                </Form.Group>
              </Col>

              <h4>Vehicle Details</h4>
              <Col xs={12} md={6}>
                <Form.Group className="mb-3">
                  <Form.Label>
                    {"Vehicle Owner Name"}
                    <span className="redStreSpan">*</span>
                  </Form.Label>
                  <Form.Control
                    type="text"
                    value={uploadFormObj?.vehicle_owner_name || ""}
                    required
                    onChange={(e) =>
                      onSelectValueValidation("vehicle_owner_name", e.target.value, 50)
                    }
                  />
                  {!isEmpty(errorMsg.vehicle_owner_name) && (
                    <p className="error-msg">{errorMsg.vehicle_owner_name}</p>
                  )}
                </Form.Group>
              </Col>
              <Col xs={12} md={6}>
                <Form.Group className="mb-3">
                  <Form.Label>
                    {"Registration Number"}
                    <span className="redStreSpan">*</span>
                  </Form.Label>
                  <Form.Control
                    type="text"
                    value={uploadFormObj?.vehicle_reg_no || ""}
                    required
                    style={{ textTransform: "uppercase" }} // 👈 makes text appear uppercase
                    onChange={(e) =>
                      onSelectValueValidation("vehicle_reg_no", e.target.value.toUpperCase(), 11)
                    }
                    maxLength={11}
                  />
                </Form.Group>
              </Col>
              <Col xs={12} md={6}>
                <Form.Group className="mb-3">
                  <Form.Label>
                    {"RC Number"}
                    <span className="redStreSpan">*</span>
                  </Form.Label>
                  <Form.Control
                    type="text"
                    required
                    value={uploadFormObj?.vehicle_rc_no || ""}
                    onChange={(e) => onSelectValueValidation("vehicle_rc_no", e.target.value, 50)}
                  />
                </Form.Group>
              </Col>
              <Col xs={12} md={6}>
                <Form.Group className="mb-3">
                  <Form.Label>
                    Vehicle Make & Type<span className="redStreSpan">*</span>
                  </Form.Label>
                  <Select
                    value={
                      uploadFormObj?.logistic_vehicle_type
                        ? {
                            value: uploadFormObj?.logistic_vehicle_type,
                            label: vehicleTypesList.find(
                              (vt) => vt.id === uploadFormObj?.logistic_vehicle_type,
                            )?.label,
                          }
                        : null
                    }
                    onChange={(selected) => {
                      console.log("---> selected: ", selected);
                      onSelectValue("logistic_vehicle_type", selected?.value || null);
                      onSelectValue(
                        "vehicle_make",
                        vehicleTypesList.find((vt) => vt.id === selected.value)?.make,
                      );
                      onSelectValue(
                        "vehicle_payload_capacity",
                        vehicleTypesList.find((vt) => vt.id === selected.value)?.max_payload,
                      );
                    }}
                    options={vehicleTypesList.map((s) => ({
                      value: s.id,
                      label: s.label,
                    }))}
                    placeholder="-- Select Vehicle Make & Type --"
                    isSearchable={true}
                    className="react-select-container"
                    classNamePrefix="react-select-register"
                  />
                </Form.Group>
              </Col>
              <Col xs={12} md={6}>
                <Form.Group className="mb-3">
                  <Form.Label>Body Type</Form.Label>
                  <Form.Control
                    type="text"
                    disabled
                    value={uploadFormObj?.vehicle_body_type || "Covered"}
                    onChange={(e) =>
                      onSelectValueValidation("vehicle_body_type", e.target.value, 50)
                    }
                  />
                </Form.Group>
              </Col>
              <Col xs={12}>
                <Form.Group className="mb-3">
                  <Form.Label>
                    {"RC Copy (PNG/JPG/PDF ≤ 2MB)"}
                    <span className="redStreSpan">*</span>
                  </Form.Label>
                  {isUpdateMode && (
                    <CustomDragDrop
                      onUplodfiles={handleFileChange}
                      nameKey={"vehicle_rc_copy"}
                      allowMultiple={false}
                      existingFiles={
                        uploadFormObj?.vehicle_rc_copy ? [uploadFormObj?.vehicle_rc_copy] : []
                      }
                    />
                  )}
                  {isCreateMode && (
                    <CustomDragDrop
                      onUplodfiles={handleFileChange}
                      nameKey={"vehicle_rc_copy"}
                      allowMultiple={false}
                    />
                  )}
                </Form.Group>
              </Col>
              <Col xs={12}>
                <Form.Group className="mb-3">
                  <Form.Label>
                    {"Insurance Copy (PNG/JPG/PDF ≤ 2MB)"}
                    <span className="redStreSpan">*</span>
                  </Form.Label>
                  {isUpdateMode && (
                    <CustomDragDrop
                      onUplodfiles={handleFileChange}
                      nameKey={"insurance_copy"}
                      allowMultiple={false}
                      existingFiles={
                        uploadFormObj?.insurance_copy ? [uploadFormObj?.insurance_copy] : []
                      }
                    />
                  )}
                  {isCreateMode && (
                    <CustomDragDrop
                      onUplodfiles={handleFileChange}
                      nameKey={"insurance_copy"}
                      allowMultiple={false}
                    />
                  )}
                </Form.Group>
              </Col>
              <Col xs={12}>
                <Form.Group className="mb-3">
                  <Form.Label>
                    {"Transport Permit Copy (PNG/JPG/PDF ≤ 2MB)"}
                    <span className="redStreSpan">*</span>
                  </Form.Label>
                  {isUpdateMode && (
                    <CustomDragDrop
                      onUplodfiles={handleFileChange}
                      nameKey={"transport_permit_copy"}
                      allowMultiple={false}
                      existingFiles={
                        uploadFormObj?.transport_permit_copy
                          ? [uploadFormObj?.transport_permit_copy]
                          : []
                      }
                    />
                  )}
                  {isCreateMode && (
                    <CustomDragDrop
                      onUplodfiles={handleFileChange}
                      nameKey={"transport_permit_copy"}
                      allowMultiple={false}
                    />
                  )}
                </Form.Group>
              </Col>
              <Col xs={12}>
                <Form.Group className="mb-3">
                  <Form.Label>
                    {"Vehicle Images (Front, Back, Side) (PNG/JPG ≤ 2MB)"}
                    <span className="redStreSpan">*</span>
                  </Form.Label>
                  {isUpdateMode && (
                    <CustomDragDrop
                      onUplodfiles={handleFileChange}
                      nameKey={"vehicle_images"}
                      allowMultiple={true}
                      existingFiles={normalizeImages(uploadFormObj?.vehicle_images)}
                    />
                  )}
                  {isCreateMode && (
                    <CustomDragDrop
                      onUplodfiles={handleFileChange}
                      nameKey={"vehicle_images"}
                      allowMultiple={true}
                    />
                  )}
                </Form.Group>
              </Col>
            </Row>

            <div className="action-buttons">
              <CustomButton
                buttonClasses="close-btn"
                onClick={() => {
                  setIsCreateMode(false);
                  setIsUpdateMode(false);
                  getOtherVehicles();
                }}
                disabled={requestCall?.loading}
              >
                <i className="bi bi-x-lg"></i> {"Close"}
              </CustomButton>
              <CustomButton
                buttonClasses={!requestCall?.loading ? "submit-btn" : "submit-btn-loading"}
                type="submit"
                loading={requestCall?.loading}
              >
                <i className="bi bi-floppy"></i> {isCreateMode ? "Create" : "Update"}
              </CustomButton>
            </div>
          </Form>
        </Row>
      </>
    );
  };

  const handleEdit = (vehicle) => {
    // console.log("Edit vehicle:", vehicle);
    setIsUpdateMode(true);
    setIsCreateMode(false);
    setUploadFormObj({
      ...vehicle,
      logistic_vehicle_type: vehicle.vehicle_type_id || null,
    });
  };

  const handleDelete = async (vehicleId) => {
    console.log("handleDelete: vehicleId: ", vehicleId);
    const isConfirmed = await confirm("Are you sure you want to delete this vehicle?", "");
    if (isConfirmed) {
      setLoading(true);
      try {
        const response = await axios.delete(
          `${BHAREE_BASE_URL_LOCAL}/logistics/deleteVehicle/${userId}/${vehicleId}`,
          {
            headers: {
              Authorization: `Bearer ${localStorage.jwtToken} `,
            },
          },
        );

        if (response && response?.data) {
          if (response?.data?.success) {
            getOtherVehicles();
          }
        }
      } catch (error) {
        console.error("Upload error:", error.response || error.message);
        throw error;
      } finally {
        setLoading(false);
      }
    }
  };

  const handleAvailableChange = async (vehicleId) => {
    console.log("handleAvailableChange: vehicleId: ", vehicleId);
    setLoading(true);
    try {
      const response = await axios.get(
        `${BHAREE_BASE_URL_LOCAL}/logistics/changeAvailableStatus/${userId}/${vehicleId}`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.jwtToken} `,
          },
        },
      );

      if (response && response?.data) {
        if (response?.data?.success) {
          getOtherVehicles();
        }
      }
    } catch (error) {
      console.error("Upload error:", error.response || error.message);
      throw error;
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      {DialogModal}
      {loading && <PageSpinner />}
      {(() => {
        if (!isCreateMode && !isUpdateMode) {
          if (otherVehicles.length > 0) {
            return (
              <>
                <Row className="m-0 p-0 mt-2">
                  <Col md={6} className="text-start">
                    <h4 className="mb-0">Vehicle List</h4>
                  </Col>
                  <Col md={6} className="text-end">
                    <Button
                      className="btn-theme"
                      size="sm"
                      onClick={() => {
                        addVehicleInfo("add");
                      }}
                    >
                      <i className="bi bi-plus-lg"></i> Add More
                    </Button>
                  </Col>
                </Row>
                <VehicleList
                  vehicles={otherVehicles}
                  onEdit={handleEdit}
                  onDelete={handleDelete}
                  onAvailableChange={handleAvailableChange}
                />
              </>
            );
          } else {
            return (
              <>
                <p className="mt-2">No additional vehicles to display.</p>
                <Button
                  className="btn-theme"
                  size="sm"
                  onClick={() => {
                    addVehicleInfo("add");
                  }}
                >
                  <i className="bi bi-plus-lg"></i> Add
                </Button>
              </>
            );
          }
        } else {
          return vehicleInfoForm();
        }
      })()}
    </>
  );
};

export default VehicleInfo;
